module.exports = __webpack_public_path__ + "static/media/51jsr4a+4LL._AC_SL1001_.9323ce8a.jpg";